import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import PropTypes from "prop-types";


const PrivateRoute = ({ children }) => {
    PrivateRoute.propTypes = {
        children:PropTypes.any
    };
    const navigate = useNavigate();
    const token = Cookies.get('login_token');

    useEffect(() => {
        if (!token) {
            navigate('/authentication/sign-in');
        }
    }, [navigate, token]);

    if (!token) {
        return null;
    }

    return <>{children}</>;
};

export default PrivateRoute;